import { render, staticRenderFns } from "./mobileMatter.vue?vue&type=template&id=2d565e3a&scoped=true&"
import script from "./mobileMatter.vue?vue&type=script&lang=js&"
export * from "./mobileMatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d565e3a",
  null
  
)

export default component.exports